import React, { useState } from "react";
import { Card, CardMedia, Typography, Avatar, Box } from "@mui/material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import NumericKeypadModal from "./NumericKeypadModal";
import fichajesService from "../servicios/fichajes.service";
import { IniciarPausa, FinalizarPausa } from "../servicios/pausas.service";
import reloj from "./../recursos/avatar icon_4013519.png";
import axios from "axios";

const UserCard = ({
  name,
  codigo,
  fotoPerfil,
  tipo,
  ultimoFichajeHora,
  idUsuario,
  refrescar,
  setRefrescar,
  sedes,
  id_empresaSede,
  usuario,
}) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [mensaje, setMensaje] = useState("");
  const [enPausa, setenPausa] = useState(false);

  const handleCardClick = () => {
    setModalOpen(true);
  };

  const handleModalClose = () => {
    setModalOpen(false);
  };
  const comprobarimagen = (imagen) => {
    fetch("https://api.fichajedigital.com/usuarios/imagenes/" + imagen + ".jpg")
      .then(() => {
        return true;
      })
      .catch(() => {
        return false;
      });
  };
  const handleAction = (actionType, pin, sede) => {
    console.log(
      `AcciÃ³n: ${actionType}, PIN: ${pin}, idUsuario:${idUsuario}, sede:${sede}`,
    );
    if (pin.length == 0) {
      setMensaje("El PIN no puede estar vacio");
      return;
    }
    setMensaje("");

    // return

    // AquÃ­ puedes agregar la lÃ³gica para procesar la entrada/salida
    if (actionType == "Entrada" || actionType == "Salida") {
      fichajesService(idUsuario, actionType, pin, sede)
        .then((r) => {
          console.log(r);
          setRefrescar(!refrescar);
          setModalOpen(false);
        })
        .catch((err) => {
          console.log(err.response.data.message);
          setMensaje(err.response.data.message);
        });
    }
    if (actionType == "InicioPausa") {
      IniciarPausa(idUsuario, pin, sede)
        .then((r) => {
          console.log(r);
          setRefrescar(!refrescar);
          setModalOpen(false);
        })
        .catch((err) => {
          console.log(err.response.data.message);
          setMensaje(err.response.data.message);
        });
    }
    // setModalOpen(false);
  };
  // Estado del usuario: verde = dentro (Entrada), rojo = fuera (Salida)
  const dentro = tipo === "Entrada";

  return (
    <>
      <Card
        key={idUsuario}
        sx={{
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          alignItems: "center",
          textAlign: "center",
          p: 2,
          borderRadius: 2,
          border: "1px solid",
          borderColor: dentro ? "rgba(46,125,50,0.45)" : "rgba(198,40,40,0.45)",
          borderTop: "4px solid",
          borderTopColor: dentro ? "#2e7d32" : "#c62828",
          backgroundColor: dentro
            ? "rgba(76,175,80,0.20)"
            : "rgba(244,67,54,0.16)",
          boxShadow: "0 4px 14px rgba(0,0,0,0.12)",
          transition: "transform .12s ease, box-shadow .12s ease",
          "&:hover": {
            transform: "translateY(-2px)",
            boxShadow: "0 8px 22px rgba(0,0,0,0.18)",
          },
          cursor: "pointer",
        }}
        onClick={handleCardClick}
      >
        {/* Bloque 1: Avatar */}
        <Box>
          {fotoPerfil ? (
            <Avatar
              src={
                "https://api.fichajedigital.com/usuarios/imagenes/" +
                fotoPerfil +
                `?${new Date().getTime()}`
              }
              sx={{ width: 90, height: 90 }}
            >
              {/* <AccountCircleIcon sx={{ width: '100%', height: '100%' }} /> */}
            </Avatar>
          ) : (
            <Avatar src={reloj} sx={{ width: 90, height: 90 }}>
              {/* <AccountCircleIcon sx={{ width: '100%', height: '100%' }} /> */}
            </Avatar>
          )}
        </Box>

        {/* Bloque 2: Nombre */}
        <Box>
          <Typography
            gutterBottom
            variant="button"
            sx={{
              minHeight: "3em",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {name}
          </Typography>
        </Box>

        {/* Bloque 3: Resto de datos */}
        <Box>
          <Typography variant="body2" color="text.secondary">
            Código: {codigo}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Tipo: {tipo}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {ultimoFichajeHora}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {usuario?.tiempoefectivo?.formato_horas}
          </Typography>
        </Box>
      </Card>
      <NumericKeypadModal
        open={modalOpen}
        onClose={handleModalClose}
        onAction={handleAction}
        ultimotipo={tipo}
        mensaje={mensaje}
        setMensaje={setMensaje}
        nombre={name}
        sedes={sedes}
        id_empresaSede={id_empresaSede}
        usuario={usuario}
      />
    </>
  );
};

export default UserCard;
